module.exports = __webpack_public_path__ + "img/le-devoir.357b6a3d.svg";